







































































































































































































































import { Component, Vue } from "vue-property-decorator";
import SourceCodeContainer from "@/components/SourceCodeContainer.vue";
@Component({
  name: "ButtonFive",
  components: {
    SourceCodeContainer
  }
})
export default class ButtonFive extends Vue {}
